import { CsvJerseyPlayer } from "../Players.types";

export type CsvJerseyRow = {
  playerId?: string;
  playerID?: string;
  jerseyNumber?: string | number;
  displayName?: string;
  playerName?: string;
};

const DIGITS_ONLY = /^\d+$/;

const parseDigitOnlyInteger = (
  raw: string | number | undefined | null,
): number | null => {
  if (typeof raw === "number") {
    return Number.isSafeInteger(raw) ? raw : null;
  }

  const text = String(raw ?? "").trim();
  if (!DIGITS_ONLY.test(text)) {
    return null;
  }

  const value = Number(text);
  return Number.isSafeInteger(value) ? value : null;
};

const readNumericPlayerId = (row: CsvJerseyRow): number => {
  const fromPlayerID = parseDigitOnlyInteger(row.playerID);
  if (fromPlayerID !== null && fromPlayerID > 0) {
    return fromPlayerID;
  }

  const fromPlayerId = parseDigitOnlyInteger(row.playerId);
  return fromPlayerId ?? NaN;
};

export const collectCsvJerseyPlayers = (
  rows: CsvJerseyRow[],
): CsvJerseyPlayer[] => {
  const playersById = new Map<number, CsvJerseyPlayer>();

  for (const row of rows) {
    const playerID = readNumericPlayerId(row);
    const jerseyNumber = parseDigitOnlyInteger(row.jerseyNumber);

    if (!Number.isFinite(playerID) || playerID <= 0) {
      continue;
    }
    if (jerseyNumber === null || jerseyNumber < 0 || jerseyNumber > 99) {
      continue;
    }

    playersById.set(playerID, {
      playerID,
      jerseyNumber,
      displayName:
        row.displayName?.trim() || row.playerName?.trim() || undefined,
    });
  }

  return Array.from(playersById.values());
};
